// From Plans the top amount is the plan total, so what the patient actually pays at the
// kiosk is the upfront part — or the whole amount when an auto-recurring plan starts today.
// Anything else is a plan that only needs the card on file, with nothing charged now.
export const resolveKioskPaidAmount = (plan, values) => {
  const upfront = Number(plan?.upfrontPayment) || 0;
  if (upfront > 0) return upfront;

  if (plan?.type === 'auto-recurring' && plan?.chargeTime === 'immediately') {
    return Number(values?.amount) || 0;
  }

  return 0;
};
